import axios from 'axios'
import AuthService from '../services/auth'
// import apiCall from '../utils/api'

const user = JSON.parse(localStorage.getItem('user'))
const initialState = (user && user.verifiedOTP)
  ? { status: { authenticated: true, loggedIn: true }, token: localStorage.getItem('user-token'), user }
  : { status: { auth: false, loggedIn: false }, token: null, user: null }

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    /**
     * POSTs user auth credentials to API login endpoint and saves JWT to localStorage
     * @param {Object} user - A user object containing username and password properties
    */
    async login ({ commit }, user) {
      console.log('loggin in')
      // try {
      const authResponse = await axios.post(`${process.env.VUE_APP_API_BASEURL}/auth/login`, user)
      if (authResponse) {
        commit('loginSuccess', authResponse.data)
        return authResponse.data
      }
    },
    logout ({ commit }) {
      AuthService.logout()
      commit('logout')
    },
    register ({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess')
          return Promise.resolve(response.data)
        },
        error => {
          commit('registerFailure')
          return Promise.reject(error)
        }
      )
    },
    /**
     * POSTs supplied TOTP token and user to API login endpoint and saves JWT to localStorage
     * @param {Object} user - An object containing username and password properties
    */
    async totpLogin ({ commit }, user) {
      try {
        const authResponse = await axios.post(`${process.env.VUE_APP_API_BASEURL}/auth/login/totp`, user)
        // get the token from the response header
        const token = authResponse.headers.authorization
        localStorage.setItem('user-token', token)
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        commit('authSuccess', { user: authResponse.data, token })
        return authResponse
      } catch (err) {
        console.error(err)
      }
    }
  },
  mutations: {
    authSuccess (state, authState) {
      state.status.authenticated = true
      state.user = authState.user
      state.token = authState.token
    },
    loginSuccess (state, user) {
      state.status.loggedIn = true
      state.user = user
    },
    loginFailure (state) {
      state.status.loggedIn = false
      state.user = null
    },
    logout (state) {
      state.status.loggedIn = false
      state.token = null
      state.user = null
    },
    registerSuccess (state) {
      state.status.loggedIn = false
    },
    registerFailure (state) {
      state.status.loggedIn = false
    }
  }
}
